import type { Node } from "@tiptap/pm/model";

export const cellIsInline = (node: Node) => {
	if (node.childCount !== 1) return false;
	if (node.firstChild.type.name !== "paragraph") return false;

	let inline = true;
	node.firstChild.forEach((child) => {
		if (!child.isInline || child.type.name === "hard_break" || child.type.name === "br") inline = false;
	});
	return inline;
};

// A cell holding a block expands the whole row: no line carries the tags of one cell with the content of another.
export const rowIsPacked = (row: Node) => {
	let packed = true;
	row.forEach((cell) => {
		if (!cellIsInline(cell)) packed = false;
	});
	return packed;
};
